export const BookingForm = class {
  constructor() {
    this.$bookingLink = $();
    this.selectors = {
      link: '.js-booking'
    };
    this.trackingData = {
      clickCode: '',
      gaCategory: PAGE_SCRIPTS.page_template,
      gaAction: 'booking'
    };

    $(this.selectors.link).off().on('click', (e) => {
      this.submitBooking($(e.currentTarget));
    });
  }

  submitBooking($link) {
    this.$bookingLink = $link;
    if (!this.$bookingLink.next('form').length) {
      this.$bookingLink.after(this.tplBookingForm());
    }
    this.$bookingLink.parent().find('form').submit();
  }

  tplBookingForm() {
    const dataset = this.$bookingLink.data();
    const accomsCode = 'accoms[' + (typeof dataset.upgradecode !== 'undefined' ? dataset.upgradecode : dataset.housingcode) + ']';

    let formInputs = {
      universId: GLOBAL_SCRIPTS.UNIVERS_ID,
      market: GLOBAL_SCRIPTS.MARKET_CODE,
      language: GLOBAL_SCRIPTS.LANGUAGE_CODE,
      codedes: dataset.code,
      dateIn: dataset.start,
      duration: dataset.duration,
      codeportal: SEARCH_SCRIPTS.PORTAL_CODE,
      [accomsCode]: 1,
      referer: window.location.href,
      'codeaction[0]': dataset.actioncodecode,
      'currency[code]': GLOBAL_SCRIPTS.CURRENCY_CODE,
      'currency[rate]': 1,
      'currency[symbol]': GLOBAL_SCRIPTS.CURRENCY_SYMBOL,
      'currency[isAfter]': GLOBAL_SCRIPTS.CURRENCY_IS_AFTER,
      'participants[0][adult]': dataset.adultsnb,
      'participants[0][senior]': dataset.seniorsnb,
      'participants[0][child]': dataset.childrennb,
      'participants[0][pet]': dataset.petsnb
    };

    // If Booking upgrade
    if (typeof dataset.originalhousing !== 'undefined') {
      formInputs = {
        ...formInputs,
        originalHousing: dataset.originalhousing,
        originalHousingId: dataset.originalhousingid,
        originalHousingPrice: dataset.originalhousingprice,
        partnerId: 'UPGRADE01',
        ratePlanId: 'UPGRADE01'
      };
    } else {
      formInputs['typos[0]'] = dataset.housingcode;
    }

    // If MultiCottage
    if (typeof dataset.adultsnb2 !== 'undefined') {
      formInputs = {
        ...formInputs,
        'participants[1][adult]': dataset.adultsnb2,
        'participants[1][senior]': dataset.seniorsnb2,
        'participants[1][child]': dataset.childrennb2,
        'participants[1][pet]': dataset.petsnb2,
        'typos[1]': dataset.housingcode2,
        'codeaction[1]': dataset.actioncodecode2
      };
      const accomsCode2 = 'accoms[' + dataset.housingcode2 + ']';
      formInputs[(accomsCode2)] = 1;
    }

    if (GLOBAL_SCRIPTS.UNIVERS.toUpperCase() === 'SP' || dataset.brandcode === 'SP') {
      formInputs.branding = 'SP';
    }

    if (GLOBAL_SCRIPTS.UNIVERS.toUpperCase() === 'FBA') {
      formInputs = {
        ...formInputs,
        collaboration_code: GLOBAL_SCRIPTS.COLLABORATION_CODE,
        soc: GLOBAL_SCRIPTS.SOCIETY_CODE,
        user_collaboration_type: GLOBAL_SCRIPTS.USER_COLLABORATION_TYPE,
        user_name: GLOBAL_SCRIPTS.USER_NAME,
        user_society_code: GLOBAL_SCRIPTS.SOCIETY_CODE,
        gtm: GLOBAL_SCRIPTS.GTM_ID,
        crs: 'RES',
        x: 1
      };
    }

    // Create form from dataset values
    const $form = $('<form>', {class: 'u-Hidden', action: GLOBAL_SCRIPTS.BOOKING_URL + '/index', method: 'post'});

    $.each(formInputs, function(key, val) {
      $form.append($('<input>', {type: 'hidden', name: key, value: val}));
    });

    dataset.ages.forEach((age) => $form.append($('<input>', {
      type: 'hidden',
      name: 'participants[0][ages][]',
      value: age
    })));

    if (typeof dataset.ages2 !== 'undefined') {
      dataset.ages2.forEach((age) => $form.append($('<input>', {
        type: 'hidden',
        name: 'participants[1][ages][]',
        value: age
      })));
    }

    return $form;
  }
};